import { LitElement, html } from 'lit';
import { uid } from 'uid';
import { classMap } from 'lit/directives/class-map.js';

// TODO what's for the below line?
// import '../fil-toast.component';
import componentStyles from './fil-toaster.styles.js';

/**
 * @tag fil-toaster
 * @property {boolean}[autoHide] Whether to hide the component automatically
 * @property {number}[duration] Duration to hide the component
 * @property {string}[position] Position of the component
 * @property {number}[zIndex] z-index of the component
 */
export class FilToaster extends LitElement {
  static properties = {
    autoHide: { type: Boolean }, // auto close toasts
    duration: { type: Number }, // ms
    position: { type: String }, // top-[left|right|center|full] | bottom-[left|right|center|full]
    zIndex: { type: Number },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.autoHide = false;
    this.duration = 5000;
    this.position = 'top-right';
  }

  connectedCallback() {
    super.connectedCallback();
    const { autoHide } = this;

    // for user convenient to control Toast, for example
    // filToasterElement.addToast(newToast);
    const createToast = (content, options) => {
      const filToast = document.createElement('fil-toast');
      const {
        status = 'info',
        open = true,
        variation,
        noCloseButton = false,
        duration = options.duration ? options.duration : this.duration || 5000,
        id = uid(),
      } = options;
      filToast.setAttribute('status', status);
      if (variation) {
        filToast.setAttribute('variation', variation);
      }
      if (noCloseButton) {
        filToast.setAttribute('noCloseButton', noCloseButton);
      }
      filToast.setAttribute('open', open);
      if (autoHide) {
        filToast.setAttribute('duration', duration);
      }
      filToast.setAttribute('id', id);
      filToast.innerHTML = content;

      return filToast;
    };
    const addToast = (content, options) => {
      const oneToast = createToast(content, options);
      this.insertBefore(oneToast, this.firstChild);
    };

    this.addToast = addToast;
    this.createToast = createToast;
    // add toaster to window then user could use it easily
    if (!window.filWCToaster) {
      window.filWCToaster = this;
    }
  }

  onSlotChange() {
    this.toasts = [...this.querySelectorAll('fil-toast')];
    const { autoHide, duration } = this;
    if (autoHide) {
      this.toasts.forEach(toast => {
        if (!toast.hasAttribute('data-duration-settled')) {
          toast.setAttribute('duration', duration);
          toast.setAttribute('data-duration-settled', 'true');
        }
      });
    }
  }

  removeToast(event) {
    event.preventDefault();
    const { target } = event;
    this.toasts.forEach(toast => {
      if (toast === target) {
        toast.remove();
      }
    });
  }

  render() {
    const classes = {
      [`fil-toaster--${this.position}`]: this.position,
    };

    return html`<div
      class="fil-toaster${classMap(classes)}"
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      @close.gds.toast=${this.removeToast}
    >
      <div class="fil-toaster-slot">
        <slot @slotchange=${this.onSlotChange}></slot>
      </div>
    </div>`;
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('zIndex')) {
      if (this.zIndex) {
        const wrapper = this.shadowRoot.querySelector('.fil-toaster');
        wrapper.style.setProperty('--fil-z-index-toast', this.zIndex);
      }
    }
  }
}

export default FilToaster;
